import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { Workflow } from 'src/app/parametrage/core/model/workflow';
import { UserService } from 'src/app/shared/directives/user.service';
import { WorkflowService } from 'src/app/parametrage/core/service/workflow.service';
import { KeycloakService } from 'src/app/core/services/auth/keycloak.service';
import { UrlTrackingService } from 'src/app/core/services/utils/url-tracking-service';
import { RequestDTO } from 'src/app/core/services/business/model/request-dto';
import { FormulaireDTO } from 'src/app/parametrage/core/model/formulaire-dto';
import { LibererDossier } from 'src/app/parametrage/core/model/request/liberer-dossier';
import { AnnulerCorrection } from 'src/app/mon-portefeuille/core/model/annuler-correction';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParticulierService } from '../core/service/particulier.service';
import { FormulaireService } from 'src/app/parametrage/core/service/formulaire.service';
import { RepartiteurService } from 'src/app/mon-portefeuille/core/service/repartiteur.service';
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { CorrectionHistoryService } from 'src/app/mon-portefeuille/core/service/correction-history.service';
import { DetenteurComponent } from 'src/app/formulaire/modal/detenteur/detenteur.component';
import { SuiviComponent } from 'src/app/formulaire/modal/suivi/suivi.component';
import { AbandonnerDossierComponent } from 'src/app/formulaire/modal/abandonner-dossier/abandonner-dossier.component';
import { ChangerInitiateurDossierComponent } from 'src/app/formulaire/modal/changer-initiateur-dossier/changer-initiateur-dossier.component';
import { ReactiverDossierComponent } from 'src/app/formulaire/modal/reactiver-dossier/reactiver-dossier.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Moment } from 'moment';
import * as moment from 'moment';

@Component({
  selector: 'app-dossier-historique-all',
  templateUrl: './dossier-historique-all.component.html',
  styleUrls: ['./dossier-historique-all.component.scss']
})
export class DossierHistoriqueAllComponent implements OnInit {

  selectedDate: {startDate: Moment, endDate: Moment} = null;
  startDate : String = null;
  endDate : String = null;

  workflowcategorie: String = "PARTICULIER";
  workflows: Workflow[];
  workflow: Workflow;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };


  isLoadingResults = true;

  dossiers: RequestDTO[];
  formulaire: FormulaireDTO;

  page: number = 0;
  totalElements: number = 0;
  filter: String = "";
  state: String[] = ["ENCOURS","APPROUVE","REJETE","MISEENPLACE","ENATTENTECOMPLEMENT","ABANDONNE"];

  libererDossier: LibererDossier;
  annulerCorrection: AnnulerCorrection;

  myForm:FormGroup;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  requestStatues: any[] = [];
  selectedItems: any[] = [];
  dropdownSettings: any = {};

  constructor(
    private userService: UserService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _workflowService: WorkflowService,
    private _keycloakService: KeycloakService,
    private _urlTrackingService: UrlTrackingService,
    private modalService: NgbModal,
    private _particulierService: ParticulierService,
    private _formulaireService: FormulaireService,
    private _repartiteurService : RepartiteurService,
    private _requestService: RequestService,
    private _correctionHistoryService: CorrectionHistoryService,
    private fb: FormBuilder
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    
    //
    this.requestStatues = [
        { item_id: 1, item_text: 'ENCOURS' },
        { item_id: 2, item_text: 'APPROUVE' },
        { item_id: 3, item_text: 'REJETE' },
        { item_id: 4, item_text: 'MISEENPLACE' },
        { item_id: 5, item_text: 'ENATTENTECOMPLEMENT' },
        { item_id: 6, item_text: 'ABANDONNE' }
    ];
    
    this.selectedItems = this.requestStatues.filter(status =>
      this.state.includes(status.item_text)
    );

    this.dropdownSettings = {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: this.ShowFilter
    };
    this.myForm = this.fb.group({
      requestStatus: [this.selectedItems]
    });
    //

    this.getWorkflowsByCategorie();
    this._activatedRoute.params.subscribe((params: Params) => {
  
      if(
        params["status"] != undefined 
        && (params["startDate"] != undefined && params["startDate"] != "null") 
        && (params["endDate"] != undefined && params["endDate"] != "null")
      )
      {
        //status
        let status  = params["status"];
        const singleDecodedString = decodeURIComponent(status);
        const fullyDecodedString = decodeURIComponent(singleDecodedString);
        const statesArray = JSON.parse(fullyDecodedString);
        this.state = statesArray;

        this.selectedItems = this.requestStatues.filter(status =>
          this.state.includes(status.item_text)
        );

        this.myForm.controls['requestStatus'].setValue(this.selectedItems);

        //range
        this.selectedDate = {startDate: null, endDate: null};

        let startDate  = params["startDate"];
        const decodedStardDate = decodeURIComponent(startDate);
        this.selectedDate.startDate = moment(decodedStardDate);
        
        let endDate  = params["endDate"];
        const decodedEndDate = decodeURIComponent(endDate);
        this.selectedDate.endDate = moment(decodedEndDate);
        if(
          (this.startDate != null && this.endDate != null)
          && (this.startDate != undefined && this.endDate != undefined)
        )
        {
          this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
        }
      }
      else
      {
        this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
      }

    });

  }

  
  changeRange(event){
    // Picker emits null on clear; that can happen before ngModel updates selectedDate
    if (event == null || (event.startDate == null && event.endDate == null)) {
      if (this.startDate == null && this.endDate == null) {
        return;
      }
      this.startDate = null;
      this.endDate = null;
      this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
      return;
    }

    if (event.startDate && event.endDate) {
      this.startDate = event.startDate.format('YYYY-MM-DD HH:mm:ss');
      this.endDate = event.endDate.format('YYYY-MM-DD HH:mm:ss');
      this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
    }
  }
  
  
  selectStatus() {
      this.state = this.myForm.value.requestStatus.map(status => status.item_text);
      this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
  }

  onSelectAll(items: any[]): void {
    this.myForm.get('requestStatus').setValue(items);
    this.state = items.map(item => item.item_text);
    this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
  }

  onDeSelectAll(): void {
    this.myForm.get('requestStatus').setValue([]);
    this.state = [];
    this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
  }
  
  getWorkflowsByCategorie() {
    this._workflowService
      .getWorkflowsByCategorie(this.workflowcategorie)
      .subscribe(
        (data) => {
          this.workflows = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.workflow = this.workflows[0];
        },
        (error) => {
          console.log(error);
        }
      );
  }

  selected(workflow: Workflow) {
    this.workflow = workflow;
  }

  create(): void {
    this._router.navigate([
      this.workflow.createForm + "/" + this.workflow.code,
    ]);
  }

  
  getAll(filter, state, debut, fin, page, size) {
    this.isLoadingResults = true;

    this._particulierService
      .findAllDossier(filter, state, debut, fin, page, size, "id", "desc")
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElements = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAll(this.filter, this.state, this.startDate, this.endDate, page, 5);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page, 5);
  }

  filterByState(): void {
    this.getAll(this.filter, this.state, this.startDate, this.endDate, 0, 5);
  }

  

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  userByRole(requestId) {
    const modalRef = this.modalService.open(DetenteurComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  liberer(requestId): void {
    this.libererDossier = new LibererDossier();
    this.libererDossier.requestId = requestId;
    this._requestService
      .liberer(this.libererDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  abandonner(requestId) {
    const modalRef = this.modalService.open(AbandonnerDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
      },
      (reason) => {}
    );
  }

  changerInitiateur(requestId) {
    const modalRef = this.modalService.open(ChangerInitiateurDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
      },
      (reason) => {}
    );
  }
  
  assigneTaskForCurrentRequest(requestId) {
    this._repartiteurService.assigneTaskForCurrentRequest(requestId).subscribe(
      (data) => {
        this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  annuler(correctionId): void {
    this.annulerCorrection = new AnnulerCorrection();
    this.annulerCorrection.correctionId = correctionId;
    this._correctionHistoryService
      .annuler(this.annulerCorrection)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
        },
        (error) => {
          console.log(error);
        }
      );
  }


  reactiver(requestId) {
    const modalRef = this.modalService.open(ReactiverDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
          this.getAll(this.filter, this.state, this.startDate, this.endDate, this.page - 1, 5);
      },
      (reason) => {}
    );
  }


}
